module.exports = __webpack_public_path__ + "img/bn27.8da606ed.png";